import styles from './styles.module.scss';
import { Button } from 'components';
import { Icons } from 'pages/Profile/components/icons';

const EmptyTable = ({ firstName, lastName, clickHandler }) => {
  return (
    <div className={styles.emptyTable}>
      <div className={styles.text}>{`${firstName}${
        lastName ? ` ${lastName}` : ''
      } does not have any clients yet.`}</div>
      <Button
        type="submit"
        className={styles.assignButton}
        title={'Assign'}
        onClick={clickHandler}
        iconLeft={<Icons variant={Icons.ADD} />}
      />
    </div>
  );
};

export default EmptyTable;
